<template>
  <div>
    <p class="ruler-type-heading">{{ rulerType() }}</p>
    <div
      :style="
        `background:${local_ruler.styles.bg_color}; border: 2px solid ${local_ruler.styles.border_color} ;height: ${local_ruler.styles.height}px; width: ${local_ruler.styles.width}px`
      "
      class="ruler-rectangle"
      v-if="numbering().length > 0"
    >
      <div
        v-for="(big_line, big_line_index) in numbering()"
        :key="`RULERLINE${big_line_index}`"
        :style="
          `height: 55%;width: ${bigLinesWidth()}px;border-left: 2px solid ${
            local_ruler.styles.font_color
          };color: ${local_ruler.styles.font_color}`
        "
        class="ruler-big-line"
      >
        <!-- numbers -->
        <div :style="`position: absolute;left: -5px; top: -25px`">
          {{ big_line }}
        </div>
        <!-- small-lines -->
        <div
          v-for="(small_line, small_line_index) in local_ruler.num_lines"
          :style="
            `width: ${smallLinesWidth()}px;height: ${getSmallMidLineHeight(
              small_line_index
            )}%; border-right: 2px solid ${local_ruler.styles.font_color}`
          "
          :key="`SMALLLINE${small_line_index}`"
          class="ruler-small-line"
        ></div>
        <div
          class="dummy-line"
          :style="`width: ${smallLinesWidth()}px;height: 100%`"
        ></div>
      </div>
      <div :style="`color: ${local_ruler.styles.font_color};position: relative;height: 55%;border-left: 2px solid ${local_ruler.styles.font_color}`">
        <!-- number -->
        <div :style="`position: absolute;left: -10px; top: -25px`">
          {{last_dummy_number}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "horizontal-ruler",
  props: {
    ruler: {
      type: Object,
    },
  },
  data() {
    return {
      local_ruler: this.ruler,
      last_dummy_number: null,
    };
  },
  methods: {
    rulerType() {
      let type = this.local_ruler.type;
      let ruler_type = { C: "In Centimeters", I: "In Inch" };

      if (type) {
        return ruler_type[type];
      } else {
        return "";
      }
    },
    numbering() {
      let start = this.local_ruler.start;
      let end = this.local_ruler.end;
      let stepsize = this.local_ruler.stepsize;

      let nums = [];

      for (let i = start; i <= end; i += stepsize) {
        nums.push(i);
      }

      this.last_dummy_number = nums[nums.length -1]

      nums = nums.slice(0, nums.length -1)

      return nums;
    },
    bigLinesWidth() {
      let padding = 24 //padding inside ruler
      let nums = this.numbering();
      let width = this.local_ruler.styles.width - padding ;

      return width / nums.length;
    },
    getSmallMidLineHeight(index) {
      let half_num_lines = this.local_ruler.num_lines / 2;

      if (index == Math.floor(half_num_lines)) {
        return 65;
      } else return 40;
    },
    smallLinesWidth() {
      let num_lines = this.local_ruler.num_lines;
      let sec_width = this.bigLinesWidth();

      return sec_width / num_lines + 1;
    },
  },
};
</script>

<style scoped>
.ruler-type-heading {
  font-weight: 600;
}
.ruler-rectangle {
  position: relative;
  display: flex;
  align-items: flex-end;
  padding: 0px 10px;
}
.ruler-big-line {
  position: relative;
  display: flex;
  align-items: flex-end;
}
.ruler-small-line {
  position: relative;
}
.dummy-line {
  position: relative;
}
</style>
